import React from 'react';
import adobeWordmark from '../../assets/branding/Adobe_Wordmark_RGB_Red.png';
import { useVipMpSession } from '../../context/VipMpSessionContext';

export function AdobeLoginView() {
  const session = useVipMpSession();

  return (
    <div className="adobe-auth-shell">
      <div className="adobe-auth-card">
        <img className="adobe-auth-logo" src={adobeWordmark} alt="Adobe" />
        <h1>Sign in with Adobe IMS</h1>
        <p>
          Use your Adobe account to open the VIP Marketplace exception return app. Your tokens stay on the
          server, and the browser only keeps an httpOnly session cookie.
        </p>
        {session.authError ? <div className="adobe-auth-error">{session.authError}</div> : null}
        <button type="button" className="btn btn-primary adobe-auth-button" onClick={session.loginWithAdobe}>
          Login with Adobe
        </button>
      </div>
    </div>
  );
}
